import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { slaMetricsDataResource } from '@jira/router-resources__service-desk-sla-settings/src/slaMetricsDataResource.tsx';
import { projectSettingsCustomerServiceManagementSlaRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceManagementSlaRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { serviceDeskSlaEntrypoint } from '@jira/spa-apps__project-settings-service-desk-sla-settings/src/ServiceDeskSlaEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsCustomerServiceManagementSlaPageEntrypoint = createPageEntryPoint({
	main: serviceDeskSlaEntrypoint,
});

export const projectSettingsCustomerServiceManagementSlaRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceManagementSlaRoute,
	() => ({
		group: 'project-settings-customer-service',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		meta: {
			reporting: {
				id: APP_NAMES.SLA_SETTINGS,
				packageName: toPackageName(APP_NAMES.SLA_SETTINGS),
				teamName: 'bumblebee',
			},
		},
		perfMetricKey: 'jsm-sla-settings',
		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? projectSettingsCustomerServiceManagementSlaPageEntrypoint
				: notFoundPageEntrypoint,
		resources: [
			...getServiceDeskSettingsResources(),
			slaMetricsDataResource,
			getConsolidationStateResource(),
		],
		forPaint: [LazyAtlassianNavigation],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
